<div class="indicator"></div>
<p>
	<ng-content></ng-content>
</p>
